//Vendor
import axios from 'axios'
import { format } from 'date-fns'
// import frLocale from 'date-fns/locale/fr'
import { fr, ar, enGB } from 'date-fns/locale'
//Custom
import Page from 'Scripts/classes/Page'
import { getEmbeddedFeaturedImg, getEmbeddedTerm } from 'Scripts/utils/wordpress'
import { deviceType, getCookieValue } from 'Scripts/utils/utils'
import { dataByLang } from 'Scripts/utils/lang'

//Class
export default class extends Page {
  constructor() {
    super('medias', {
      container: '.news',
      elements: {
        sliderWrapper: '.news__wrapper',
        paginationLink: '.module__btn_readmore a',
        moduleWrapper: '.module__wrapper',
        date: '.dropdown .dropdown__input_hidden[name="date"]',
        category: '.dropdown .dropdown__input_hidden[name="category"]',
        filterInput: '.dropdown .dropdown__input_hidden',
        mobileFilter: '[data-filter]',
        mobileCount: '.result__count',
      },
    })

    this.lang = getCookieValue('wp-wpml_current_language') || 'fr'
    this.locale = fr
    if (this.lang === 'ar') {
      this.locale = ar
    } else if (this.lang === 'en') {
      this.locale = enGB
    } else {
      this.locale = fr
    }
    //Properties
    this.device = deviceType()
    if (this.device === 'mobile') {
      this.mobileFilter()
    }
    //Method
    // this.exist && this.initNews()
    this.filterNews()
    this.loadData()
  }

  async loadData() {
    // const { data } = await axios.get(
    //   `${process.env.API}/posts?orderby=date&order=desc&lang=${this.lang}&_embed`
    // )

    const { data } = await axios({
      method: 'get',
      url: `${process.env.SGTMAPI}/proxy`,
      params: {
        endpoint: 'posts',
        orderby: 'date',
        order: 'desc',
        lang: this.lang,
        _embed: true,
      },
    })

    this.storeData(data)
  }

  filterNews() {
    this.elements.filterInput.forEach((input) => {
      input.addEventListener('change', () => {
        this.getNews({
          category: this.elements.category.value,
          date: this.elements.date.value,
        })
      })
    })
  }

  mobileFilter() {
    this.elements.mobileFilter?.forEach((elm) => {
      elm.addEventListener('click', () => {
        // remove active class from all buttons of the same group
        const siblings = elm.parentNode.children
        for (let i = 0; i < siblings.length; i++) {
          siblings[i].classList.remove('active')
        }
        // add active class to the clicked button
        elm.classList.add('active')
        // get the clicked button's data-filter
        let date = 'desc'
        let category = ''

        // get others filters
        switch (elm.dataset.filter) {
          case 'category':
            category = elm.dataset.value
            date = [...this.elements.mobileFilter].filter(
              (elm) => elm.classList.contains('active') && elm.dataset.filter === 'date'
            )[0].dataset.value
            break
          case 'date':
            date = elm.dataset.value
            category = [...this.elements.mobileFilter].filter(
              (elm) => elm.classList.contains('active') && elm.dataset.filter === 'category'
            )[0].dataset.value
            break
        }

        this.getNews({ date, category })
      })
    })
  }

  storeData(data) {
    // console.log(data)
    const dataToStore = data.map((item) => ({
      id: item.id,
      title: item.title.rendered,
      featuredimg: item._embedded['wp:featuredmedia'][0].media_details.sizes.nextImg.source_url,
    }))
    localStorage.setItem('posts', JSON.stringify(dataToStore))
  }

  async getNews(filters) {
    //Get filters
    const date = filters.date ? filters.date : 'desc'
    //Retrieve data
    // const { data } = await axios.get(
    //   `${process.env.API}/posts?orderby=date&order=${date}&lang=${this.lang}&_embed`
    // )

    const { data } = await axios({
      method: 'get',
      url: `${process.env.SGTMAPI}/proxy`,
      params: {
        endpoint: 'posts',
        orderby: 'date',
        order: date,
        lang: this.lang,
        _embed: true,
      },
    })

    const newData = filters.category
      ? data.filter((item) => item.categories.indexOf(parseInt(filters.category)) !== -1)
      : data
    const length = newData.length
    const news = await this.Layout(newData)

    //store filtred data (id, title and featured image) in localstorage
    this.storeData(newData)

    //update HTML

    this.elements.paginationLink.dataset.count = length
    this.elements.mobileCount.innerText = length
    this.elements.paginationLink.dataset.page = 1
    this.elements.moduleWrapper.innerHTML = news
    if (this.elements.paginationLink.dataset.perpage >= length) {
      this.elements.paginationLink.classList.add('is__hidden')
    } else {
      this.elements.paginationLink.classList.remove('is__hidden')
    }

    //Reinit components
    this.initPagination()
    this.initModal()
    this.show()
    this.emitEvent()
  }

  async Layout(data) {
    const layout = await Promise.all(
      data.map(
        async (item) => ` <div class="module__item is__hidden" data-animation="reveal">
                                                                  <div class="module__item_img" data-modal="media" data-id="${
                                                                    item.id
                                                                  }" data-module="posts" data-scroll="true">
                                                                    <picture> <img src="${await getEmbeddedFeaturedImg(
                                                                      item._embedded
                                                                    )}" alt="${
          item.title.rendered
        }"></picture>
                                                                  </div>
                                                                  <div class="module__item_data" data-animation="reveal">
                                                                    <h3 class="module__item_title">${
                                                                      item.title.rendered
                                                                    }</h3>
                                                                    <div class="module__item_meta">
                                                                      <div class="module__item_date">${
                                                                        dataByLang[this.lang].datedu
                                                                      } ${format(
          new Date(item.date),
          'dd MMMM yyyy',
          { locale: this.locale }
        )}</div>
                                                                      <div class="spacer__line"> </div>
                                                                      <div class="module__item_cat">${await getEmbeddedTerm(
                                                                        item._embedded
                                                                      )}</div>
                                                                    </div>
                                                                  </div>
                                                                </div>`
      )
    )

    return layout.join('')
  }

  emitEvent() {
    window.dispatchEvent(new Event('resize'))
  }

  /**
   * Animations.
   */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

  onResize() {
    return super.onResize()
  }

  destroy() {}
}
